import { useLocation } from "react-router-dom";

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function unwrapOr<T>(value: T | undefined | null, or: () => T): T {
  return value ?? or();
}
